import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-4 sf-pro"
}
const _hoisted_2 = { class: "whitespace-pre-line" }

import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { inject, ref, watch, computed } from "vue";
import { DestinyMatrix, DestinyMatrixKeysEnum } from "@/types/destinyMatrix";
import { useI18n } from "vue-i18n";
import AppSelect from "@/components/inputs/AppSelect.vue";
import ArrowButton from "@/views/Calculators/DestinyMatrix/components/buttons/ArrowButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'YearTasksAccordion',
  props: /*@__PURE__*/_mergeModels({
    matrix: {}
  }, {
    "modelValue": { type: Boolean, ...{ default: false } },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;
const isOpen = _useModel<boolean>(__props, "modelValue");
const getDescription =
  inject<(key: DestinyMatrixKeysEnum) => Promise<never>>("getDescription");

const { t } = useI18n();

watch(
  () => props.matrix,
  () => (yearsValues.value = undefined)
);

const options = [
  "0",
  "1-2",
  "2-3",
  "3-4",
  "5",
  "6-7",
  "7-8",
  "8-9",
  "10",
  "11-12",
  "12-13",
  "13-14",
  "15",
  "16-17",
  "17-18",
  "18-19",
  "20",
  "21-22",
  "22-23",
  "23-24",
  "25",
  "26-27",
  "27-28",
  "28-29",
  "30",
  "31-32",
  "32-33",
  "33-34",
  "35",
  "36-37",
  "37-38",
  "38-39",
  "40",
  "41-42",
  "42-43",
  "43-44",
  "45",
  "46-47",
  "47-48",
  "48-49",
  "50",
  "51-52",
  "52-53",
  "53-54",
  "55",
  "56-57",
  "57-58",
  "58-59",
  "60",
  "61-62",
  "62-63",
  "63-64",
  "65",
  "66-67",
  "67-68",
  "68-69",
  "70",
  "71-72",
  "72-73",
  "73-74",
  "75",
  "76-77",
  "77-78",
  "78-79",
];

const yearsValues = ref();
const selectedOption = ref(0);
const yearValueIndex = computed(() => {
  if (props.matrix === undefined) {
    return 0;
  }
  let optionBatch = selectedOption.value % 8;
  if (optionBatch === 0) {
    const r1 = props.matrix.r1;
    const edgeValues = [r1.l, r1.tl, r1.t, r1.tr, r1.r, r1.br, r1.b, r1.bl];

    return edgeValues[selectedOption.value / 8];
  }
  optionBatch = Math.trunc(selectedOption.value / 8);
  const yearsBatch = props.matrix.years[optionBatch];

  return yearsBatch[selectedOption.value - optionBatch * 8 - 1];
});

async function getData() {
  if (!yearsValues.value && props.matrix && getDescription) {
    yearsValues.value = await getDescription(DestinyMatrixKeysEnum.YEAR_TASKS);
  }
}

function updateSelectedIndex(indexDelta: number) {
  const newIndex = selectedOption.value + indexDelta;
  if (newIndex >= 0 && newIndex < options.length) {
    selectedOption.value = newIndex;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AccordionComponent, {
    type: "white",
    onOpened: getData,
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isOpen).value = $event))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.year-tasks")), 1)
    ]),
    "faq-content": _withCtx(() => [
      (yearsValues.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex items-center gap-2", {
            'pl-[42px]': selectedOption.value === 0,
          }])
            }, [
              (selectedOption.value > 0)
                ? (_openBlock(), _createBlock(ArrowButton, {
                    key: 0,
                    "arrow-direction": "left",
                    onClicked: _cache[0] || (_cache[0] = ($event: any) => (updateSelectedIndex(-1)))
                  }))
                : _createCommentVNode("", true),
              _createVNode(AppSelect, {
                class: "w-[132px]",
                items: options,
                "default-value": options[selectedOption.value],
                onSelectOption: _cache[1] || (_cache[1] = (newOption) => selectedOption.value = options.indexOf(newOption))
              }, null, 8, ["default-value"]),
              (selectedOption.value !== options.length - 1)
                ? (_openBlock(), _createBlock(ArrowButton, {
                    key: 1,
                    "arrow-direction": "right",
                    onClicked: _cache[2] || (_cache[2] = ($event: any) => (updateSelectedIndex(1)))
                  }))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_2, _toDisplayString(yearsValues.value[yearValueIndex.value]), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    "collapse-text-btn": _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.collapse")), 1)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})